import { ArrowForwardIos, DoubleArrow } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React from 'react';
import { Button } from "../../../button/Button.js";
import styles from "./Controls.module.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function Controls({
  onAllRightClick,
  onRightClick,
  onAllLeftClick,
  onLeftClick,
  className
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.gridColumnBlocker
    }), /*#__PURE__*/_jsxs("div", {
      className: classnames(styles.controls, className),
      children: [/*#__PURE__*/_jsx(Button, {
        variant: "outlined",
        noMinWidth: true,
        onClick: onAllLeftClick,
        "aria-label": "all-left",
        children: /*#__PURE__*/_jsx(DoubleArrow, {
          className: styles.arrowLeft
        })
      }), /*#__PURE__*/_jsx(Button, {
        variant: "outlined",
        noMinWidth: true,
        onClick: onLeftClick,
        "aria-label": "left",
        children: /*#__PURE__*/_jsx(ArrowForwardIos, {
          className: styles.arrowLeft
        })
      }), /*#__PURE__*/_jsx(Button, {
        variant: "outlined",
        noMinWidth: true,
        onClick: onRightClick,
        "aria-label": "right",
        children: /*#__PURE__*/_jsx(ArrowForwardIos, {})
      }), /*#__PURE__*/_jsx(Button, {
        variant: "outlined",
        noMinWidth: true,
        onClick: onAllRightClick,
        "aria-label": "all-right",
        children: /*#__PURE__*/_jsx(DoubleArrow, {
          className: styles.arrowRight
        })
      })]
    })]
  });
}